// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectRestaurantClient {
  height: 40px;
  width: 100%;
  color: #000000;
  font-family: "Montserrat Regular";
  font-weight: 400;
  font-size: 16px;
}

/* src/SelectRestaurant.scss */
.empty-list {
  font-family: "Montserrat Regular";
  font-size: 20px;
  font-weight: 700;
  color: #000000;
  margin-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/routes/pages/EstablishmentsUpdatePage/Tabs/ClientControlPage/SelectRestaurant/SelectRestaurantClient.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,cAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AACF;;AACA,8BAAA;AACA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAEF","sourcesContent":[".SelectRestaurantClient {\n  height: 40px;\n  width: 100%;\n  color: #000000;\n  font-family: 'Montserrat Regular';\n  font-weight: 400; \n  font-size: 16px;\n}\n/* src/SelectRestaurant.scss */\n.empty-list {\n  font-family: 'Montserrat Regular';\n  font-size: 20px;\n  font-weight: 700;\n  color: #000000;\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SelectRestaurantClient": `SelectRestaurantClient`,
	"empty-list": `empty-list`
};
export default ___CSS_LOADER_EXPORT___;
